export default __webpack_public_path__ + "static/sso-transformative-6af29bd5b9a395b0a4f6c07a3bc63e54.png";